const videoExtensions = new Set([
  'mp4',
  'mkv',
  'avi',
  'mov',
  'wmv',
  'flv',
  'webm',
  'm4v',
  'mpg',
  'mpeg',
  'mpe',
  '3gp',
  '3g2',
  'ogv',
  'ts',
  'm2ts',
  'mts',
  'vob',
  'f4v',
  'asf',
  'rm',
  'rmvb',
  'divx',
  'swf',
  'mxf',
  'r3d',
  'braw',
  'dv',
  'qt',
  'm1v',
  'm2v',
  'mod',
  'tod',
  'amv',
  'yuv',
  'y4m',
  'gifv'
]);

// Reads the extension from the rear (end) of the file name
export const getFileExtension = (fileName = '') => {
  // strip query string / hash in case it's a URL
  const clean = String(fileName).split(/[?#]/)[0].trim();
  const lastDot = clean.lastIndexOf('.');

  // no dot, or dot is the last character -> no extension
  if (lastDot === -1 || lastDot === clean.length - 1) return '';

  return clean.slice(lastDot + 1).toLowerCase();
};

export const isVideoFile = (fileName) => videoExtensions.has(getFileExtension(fileName));
